export default "/img/HK.0c65b4d8b491dccddd23a70fba7555d3.png";